<template lang='pug' src='./navigation-clean.pug'></template>

<script>
import Icon from 'components/icon/icon'
import FunctionButton2 from 'components/block/block-function-button-2/block-function-button-2'

export default {
  data () {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.pageYOffset,
      waypoint: (window.innerHeight * 0.1),
      isOpen: false
    }
  },
  computed: {
    props () {
      return this.$store.state.pages.nav
    },
    links () {
      return this.$router.options.routes
    },
    button () {
      return {
        path: '/contact-us',
        name: 'Contact Us'
      }
    },
    functionButton () {
      return [
        {
          label: 'Make Appointment'
        }
      ]
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
    window.addEventListener('scroll', () => {
      this.windowHeight = window.pageYOffset
    })
  },
  // mixins: [closeMenu],
  methods: {
    openModal (e) {
      this.$store.dispatch('VIEW_SHOWMODAL', true)
      this.$store.dispatch('VIEW_MODALCONTENT', e)
    },
    toggleMenu () {
      window.scrollBy(0, window.innerHeight * 0.01)
      // this.$store.state.menu ? this.$store.dispatch('VIEW_MENU', false) : this.$store.dispatch('VIEW_MENU', true)
      // this.$store.state.menu ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    },
    dropdown () {
      this.isOpen = !this.isOpen
    }
  },
  components: {
    Icon,
    FunctionButton2
  }
}
</script>



// WEBPACK FOOTER //
// navigation-clean.vue?55dc149d